export default {
  infoBlockTitle: {
    id: 'bo_sellers-orders-drawers-export_csv_file-imeis_info_text',
    defaultMessage:
      'Heads up: Your exported CSV file will only include missing IMEIs found within your applied search filters.',
  },
} as const
